<template>
  <div class="flex w-full flex-col gap-y-4 py-4">
    <div v-for="result in modelValue" :key="result.id" class="space-y-2">
      <span
        v-if="hasKnockout(result)"
        v-tooltip="getKnockoutReasons({ scorecard_result: result })"
        class="flex h-[34px] items-center justify-center"
      >
        <icon-base
          :icon="IconKnockout"
          :color="
            isKnockoutTriggered(result)
              ? UTIL_COLORS.WARNING
              : UTIL_COLORS.DEFAULT
          "
        />
      </span>
      <div v-else class="h-[34px]" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { UTIL_COLORS } from "@/helpers/constants";
import { useScorecardsServices } from "@/hooks/scorecards";

import IconKnockout from "@/components/icons/IconKnockout.vue";

import type { IScorecardResult } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  modelValue: {
    type: Array as PropType<IScorecardResult[]>,
  },
});

const { getKnockoutReasons } = useScorecardsServices();

const hasKnockout = (result: IScorecardResult) =>
  !!result.categories?.some(({ knockout }) => knockout);

const isKnockoutTriggered = (result: IScorecardResult) =>
  !!result?.knocked_out_at && !!result?.knockouts?.length;
</script>
